// main.js 或 directives.js
import Vue from 'vue';

const overflowTooltip = {
    bind(el, binding, vnode) {
        el.style.overflow = 'hidden';
        el.style.whiteSpace = 'nowrap';
        el.style.textOverflow = 'ellipsis';
        // 保存事件处理函数引用，以便 later 解绑
        const handleMouseEnter = function () {
            // 核心判断：内容的实际宽度(scrollWidth) > 容器的可见宽度(clientWidth)
            if (el.scrollWidth > el.clientWidth) {
                // 如果溢出，则设置 title 属性，浏览器会自动显示原生 tooltip
                el.title = el.innerText;
            } else {
                // 如果未溢出，移除 title 属性，防止短文本也弹出提示
                el.removeAttribute('title');
            }
        };

        // 将事件处理器存储在元素上，以便解绑
        el._tooltipHandleMouseEnter = handleMouseEnter;

        // 绑定事件
        el.addEventListener('mouseenter', handleMouseEnter);
    },

    // 元素插入后再次检查
    inserted(el) {
        // 触发一次检查，以防内容在 bind 和 inserted 之间发生变化
        if (el.scrollWidth > el.clientWidth) {
            el.title = el.innerText;
        } else {
            el.removeAttribute('title');
        }
    },

    // 解绑时清理事件监听器
    unbind(el) {
        // 移除事件监听器以避免内存泄漏
        if (el._tooltipHandleMouseEnter) {
            el.removeEventListener('mouseenter', el._tooltipHandleMouseEnter);
            el._tooltipHandleMouseEnter = null;
        }
    }
};

export default overflowTooltip;